import { ActionIcon, Tooltip } from '@mantine/core';
import * as icons from '@sloyd/icons';

export type IconButtonProps = {
  name: string;
  color?: string;
  variant?: 'subtle' | 'filled';
  size?: number;
  stroke?: number;
  disabled?: boolean;
  onClick?: () => void;
  tooltip?: string;
};

export function IconButton(props: IconButtonProps) {
  const { name, variant = 'subtle', stroke = 1, size = 30, color, disabled, tooltip } = props;
  const Cmp = (icons as any)[name];

  if (!Cmp) return null;

  const actionIcon = (
    <ActionIcon color={color} variant={variant} disabled={disabled} onClick={props.onClick}>
      <Cmp size={size} stroke={stroke} />
    </ActionIcon>
  );

  return tooltip ? (
    <Tooltip openDelay={700} label={tooltip}>
      {actionIcon}
    </Tooltip>
  ) : (
    actionIcon
  );
}

export default IconButton;
